// extracted by mini-css-extract-plugin
export default {"selectRow":"SelectInput_selectRow__QjOOH","selectLabel":"SelectInput_selectLabel__Vj7m9","requiredAsterix":"SelectInput_requiredAsterix__-X0dG"};